(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homewoods-generic-product"] && !Shopify.designMode) return;
  try {
    (() => {
 const mount = (container) => {
  container.querySelectorAll('[data-hw-generic-product]').forEach((root) => {
   if (root.dataset.genericReady) return;
   root.dataset.genericReady = 'true';
   const select = root.querySelector('[data-generic-variant]');
   const quantity = root.querySelector('[data-generic-quantity]');
   const add = root.querySelector('[data-generic-add]');
   const showMedia = (id) => {
    const media = [...root.querySelectorAll('[data-generic-media]')];
    if (!media.some((item) => item.dataset.genericMedia === id)) return;
    media.forEach((item) => {
     const active = item.dataset.genericMedia === id;
     item.hidden = !active;
     if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
    });
    root.querySelectorAll('[data-generic-show-media]').forEach((button) => button.setAttribute('aria-current', String(button.dataset.genericShowMedia === id)));
   };
   root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-generic-show-media]');
    if (button && root.contains(button)) showMedia(button.dataset.genericShowMedia);
   });
   select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (!option) return;
    root.querySelector('[data-generic-price]').textContent = option.dataset.price;
    const compare = root.querySelector('[data-generic-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
    root.querySelector('[data-generic-sku]').textContent = option.dataset.sku;
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    const minimum = Number(quantity.min);
    const increment = Number(quantity.step);
    const requested = Number(quantity.value);
    if (!Number.isInteger(requested) || requested < minimum || (requested - minimum) % increment !== 0 || (quantity.max && requested > Number(quantity.max))) quantity.value = String(minimum);
    add.disabled = option.dataset.available !== 'true';
    root.querySelector('[data-generic-add-label]').textContent = add.disabled ? add.dataset.soldOutLabel : add.dataset.availableLabel;
    if (option.dataset.media) showMedia(option.dataset.media);
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
   });
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
 else mount(document);
 document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
